import styled from 'styled-components';

export const Card = styled.div`
  background: ${(p) => p.theme.surface};
  border: 1px solid ${(p) => p.theme.border};
  border-radius: ${(p) => p.theme.radiusLg};
  box-shadow: ${(p) => p.theme.shadowSm};
  overflow: hidden;
`;

export const CardHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
  padding: 1.1rem 1.25rem;
  border-bottom: 1px solid ${(p) => p.theme.border};

  h3 {
    margin: 0;
    font-size: 1rem;
    font-weight: 700;
    color: ${(p) => p.theme.textPrimary};
  }
`;

export const CardBody = styled.div`
  padding: 1.25rem;
`;

export default Card;
